import { Outlet } from "react-router-dom";
import ClaimableAuthenticatorV2 from "../../components/shared/claimable-authenticator-v2";
import { ANONYMOUS_APPEAL_STORAGE_KEY } from "shared/src/constants/sign-out-storage-keys";

const AppealManagementAuthGate = () => {
  const hasAnonymousAppeal =
    sessionStorage.getItem(ANONYMOUS_APPEAL_STORAGE_KEY) !== null;
  return (
    <ClaimableAuthenticatorV2
      defaultTab={hasAnonymousAppeal ? "signUp" : "signIn"}
    >
      <Outlet />
    </ClaimableAuthenticatorV2>
  );
};

export default AppealManagementAuthGate;
